import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiOptimistic: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_17016)">
                <path
                    d="M11.3343 8.57668C11.616 7.88032 11.7589 7.14333 11.7589 6.37945C11.7589 4.80902 11.1473 3.33258 10.0368 2.22209C8.92633 1.11158 7.44986 0.5 5.87945 0.5C4.30904 0.5 2.83258 1.11158 1.72209 2.22207C0.611609 3.33255 0 4.80902 0 6.37945C0 7.94989 0.611584 9.42633 1.72207 10.5368C2.83255 11.6473 4.30902 12.2589 5.87943 12.2589C6.6433 12.2589 7.38029 12.116 8.07666 11.8343C8.43352 12.8054 9.36762 13.5 10.4609 13.5C11.861 13.5 13 12.361 13 10.9609C13 9.86762 12.3054 8.93352 11.3343 8.57668ZM5.87945 11.4972C3.05751 11.4972 0.761719 9.20137 0.761719 6.37945C0.761719 3.55754 3.05751 1.26172 5.87945 1.26172C8.70139 1.26172 10.9972 3.55751 10.9972 6.37945C10.9972 7.09331 10.8541 7.77992 10.5721 8.42446C9.09579 8.3522 7.85218 9.59581 7.92444 11.0721C7.27992 11.3541 6.59331 11.4972 5.87945 11.4972ZM10.4609 12.7383C9.48091 12.7383 8.68359 11.941 8.68359 10.9609C8.68359 9.98091 9.48091 9.18359 10.4609 9.18359C11.441 9.18359 12.2383 9.98091 12.2383 10.9609C12.2383 11.941 11.441 12.7383 10.4609 12.7383Z"
                    fill="#F8D200"
                />
                <path
                    d="M10.8264 10.2854L10.2324 10.8793L10.0193 10.6662C9.87059 10.5175 9.62943 10.5175 9.48069 10.6662C9.33196 10.8149 9.33196 11.0561 9.48069 11.2048L9.96312 11.6873C10.1119 11.836 10.353 11.836 10.5017 11.6873L11.365 10.824C11.5137 10.6753 11.5137 10.4341 11.365 10.2854C11.2163 10.1366 10.9751 10.1366 10.8264 10.2854Z"
                    fill="#F8D200"
                />
                <path
                    d="M8.85756 7.23831C8.89441 7.01635 8.70545 6.79857 8.48049 6.8038H3.27818C3.05322 6.79857 2.86426 7.01635 2.9011 7.23831C3.00221 7.94882 3.35671 8.60156 3.89931 9.07629C4.44726 9.55574 5.15046 9.81975 5.87932 9.81975C6.60818 9.81975 7.31135 9.55574 7.85933 9.07629C8.40195 8.60156 8.75646 7.94882 8.85756 7.23831ZM7.35779 8.50299C6.94872 8.86093 6.42367 9.05801 5.87935 9.05801C5.33502 9.05801 4.80997 8.8609 4.40087 8.50299C4.10934 8.24792 3.8905 7.92429 3.7625 7.5655H7.99616C7.86817 7.92429 7.64935 8.24792 7.35779 8.50299Z"
                    fill="#F8D200"
                />
                <path
                    d="M8.03812 5.62899C8.42762 5.62899 8.79377 5.47731 9.06914 5.20192C9.21787 5.05318 9.21785 4.81205 9.06914 4.66331C8.92042 4.51455 8.67926 4.5146 8.53052 4.66331C8.39898 4.79486 8.22414 4.86727 8.0381 4.86727C7.85211 4.86727 7.67722 4.79483 7.54567 4.66331C7.39696 4.5146 7.1558 4.5146 7.00706 4.66331C6.85832 4.81202 6.85832 5.05318 7.00706 5.20192C7.2825 5.47731 7.64866 5.62899 8.03812 5.62899Z"
                    fill="#F8D200"
                />
                <path
                    d="M4.75273 5.20192C4.90147 5.05318 4.90144 4.81205 4.75273 4.66331C4.60402 4.51455 4.36286 4.5146 4.21412 4.66331C4.08257 4.79486 3.90773 4.86727 3.72169 4.86727C3.53571 4.86727 3.36082 4.79483 3.22927 4.66331C3.08055 4.5146 2.83939 4.5146 2.69066 4.66331C2.54192 4.81202 2.54192 5.05318 2.69066 5.20192C2.96609 5.47731 3.33225 5.62899 3.72172 5.62899C4.11118 5.62899 4.47734 5.47731 4.75273 5.20192Z"
                    fill="#F8D200"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_17016">
                    <rect width="13" height="13" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiOptimistic;
